module.exports = __webpack_public_path__ + "static/assets/edd121b25c0e1409b08e4f1b313f14a7.png";